import React from 'react';
import Navbar from '../Company/About/Navbar';
import HeroSection from './HeroSection';
import WhyChooseUs from './WhyChooseUs';
import HeroImage from './HeroImage';
import SmartRecording from './SmartRecording';
import ProcessFlow from './ProcessFlow';
import CandidateScreening from './CandidateScreening';
import FrequentlyAskedQuestions from './FrequentlyAskedQuestions';
import Testimonials from './Testimonials';
import Footer from '../Company/About/Footer';

export function RecruitmentHero() {
  return (
    <div className="min-h-screen w-full bg-background">
      <Navbar />
      <HeroSection />
      <WhyChooseUs />
      <HeroImage />
      <SmartRecording />
      <ProcessFlow />
      <CandidateScreening />
      <FrequentlyAskedQuestions />
      <Testimonials />
      <Footer />
    </div>
  );
}
